import { logRecoveryEvent } from "./recoveryLog";

// Shared connectivity state so a plain module (axiosConfig.js) can drive a
// React banner without either side importing the other. Three states:
//  - "online"       nothing to show
//  - "reconnecting" a request is being retried; don't alarm the merchant yet
//  - "offline"      retries exhausted on a genuine network-level failure
let state = "online";
const listeners = new Set();

export const getConnectivityState = () => state;

export const subscribeConnectivity = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export const setConnectivityState = (next) => {
  if (next === state) return;
  state = next;
  logRecoveryEvent("connectivity-state-changed", { state: next });
  listeners.forEach((cb) => cb(state));
};

// The browser's "online" event only means the OS-level network interface came
// back — it doesn't confirm Webbieshop's API is actually reachable again. The
// normal way that gets confirmed is a real axios call succeeding (see
// axiosConfig.js's response interceptor). But if the tab is sitting idle with
// nothing making requests, that may never happen, leaving the banner stuck on
// "reconnecting" forever even though connectivity is fine. So: assume
// genuinely back online after a few quiet seconds, unless something else
// (a real request failing again) says otherwise in the meantime.
let onlineFallbackTimer = null;

window.addEventListener("offline", () => {
  clearTimeout(onlineFallbackTimer);
  setConnectivityState("offline");
});

window.addEventListener("online", () => {
  setConnectivityState("reconnecting");
  clearTimeout(onlineFallbackTimer);
  onlineFallbackTimer = setTimeout(() => {
    if (state === "reconnecting") setConnectivityState("online");
  }, 4000);
});
